import { render, staticRenderFns } from "./AthleteHighlightReelCard.vue?vue&type=template&id=4f6b64dc&scoped=true&"
import script from "./AthleteHighlightReelCard.vue?vue&type=script&lang=ts&"
export * from "./AthleteHighlightReelCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6b64dc",
  null
  
)

export default component.exports